import type {
  SaveFlatRatesPayload,
  SaveFlatRatesResponse,
} from '@fourthwall/services/dist/ShippingApiClient'
import { ShippingApiClient } from '@fourthwall/services/dist/ShippingApiClient'
import type { ApiError } from '@fourthwall/services/dist/types'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useSaveFlatRatesMutation = () => {
  const queryClient = useQueryClient()

  const saveFlatRatesMutation = useMutation<SaveFlatRatesResponse, ApiError, SaveFlatRatesPayload>({
    mutationFn: async (payload) => {
      const { data } = await ShippingApiClient.saveFlatRates(payload)

      return data
    },
    onSuccess: (data) => {
      queryClient.setQueryData(['shopShippingFlatRates', undefined], data)
    },
  })

  return {
    saveFlatRatesMutation,
  }
}
